import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], columnName: string): any[] {
    if (!items || !columnName) {
      return items;
    }
    // Filter items based on the value of the column
    return items.filter(item => item[columnName] === true);
  }
}
